import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import invStocks, { invStocksSaga } from './invStocks';
import invHistory, { invHistorySaga } from './invHistory';
import invTranInfo, { invTranInfoSaga } from './invTranInfo';
import whMaster, { whMasterSaga } from './whMaster';

const inventoryModule = combineReducers({
    invStocks,
    invHistory,
    invTranInfo,
    whMaster,
});

export function* inventoryModuleSaga() {
    yield all([
        invStocksSaga(),
        invHistorySaga(),
        invTranInfoSaga(),
        whMasterSaga(),
    ]);
}

export default inventoryModule;
